import { render, staticRenderFns } from "./twilio-send-sms-input.vue?vue&type=template&id=641c89cc&scoped=true"
import script from "./twilio-send-sms-input.vue?vue&type=script&lang=js"
export * from "./twilio-send-sms-input.vue?vue&type=script&lang=js"
import style0 from "./twilio-send-sms-input.vue?vue&type=style&index=0&id=641c89cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641c89cc",
  null
  
)

export default component.exports